module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-cs-bg-2-sp-49145fe259af354be545ba98e96cf4f0.png";